module.exports = __webpack_public_path__ + "img/renwu.5b85ac98.png";